import { createApp } from "vue";
import App from "./App.vue";
import "./assets/reset.css";
import axios from 'axios'
import VueAxios from 'vue-axios'
import './registerServiceWorker.js'

const app = createApp(App)
app.use(VueAxios, axios)
app.mount('#app')